import ReactSlider from "react-slick";

import { mergeClassNames } from "utils/common";

import "./index.scss";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

const Slider = ({ sliderRef, items = [], className, slideElementWrapperClassName, settings, ...props }) => {
	const localSettings = {
		dots: true,
		infinite: true,
		arrows: false,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		draggable: false,
		...settings,
	};

	return (
		<div className={mergeClassNames("slider-container", className)} {...props}>
			<ReactSlider ref={sliderRef}  {...localSettings}>
				{items.map((item, i) => {
					return (
						<div key={i} className={mergeClassNames("slide-element-wrapper", slideElementWrapperClassName)}>
							{item}
						</div>
					);
				})}
			</ReactSlider>
		</div>
	);
};
export default Slider;
